<template>
  <ColumnWithHelp
    :label="label"
    sortable
    :resizable="false"
    :min-width="110"
    :title="label"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_TAP_ON_INSTALL_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { installCount } }">
      {{ priceFormat(installCount) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'InstallColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    priceFormat,
  },
};
</script>
